import React from 'react';

import { FeaturePatternTrussContainer } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { editFeaturePatternContainers } from '../../../../store/actions/layout/featurePatternContainerActions';
import { isLayoutModeViewOnly } from '../../../../store/selectors/layoutModeSelectors';
import { propertiesShouldBeViewOnly } from '../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { FeaturePatternContainerPropertyControls } from './FeaturePatternContainerPropertyControls';
import { PropertiesPanelMenuButton } from './PropertiesPanelMenuButton';

/**
 * Note that we strongly desire to keep this panel as visually similar to the plural `FeaturePatternContainerProperties`
 *   panel as possible.  Please consider updating both panels when making any changes.
 */
export function FeaturePatternContainerProperties(props: { value: FeaturePatternTrussContainer }) {
  const dispatch = useAppDispatch();

  const viewOnlyProperties = useAppSelector(propertiesShouldBeViewOnly);
  const viewOnlyLayout = useAppSelector(isLayoutModeViewOnly);
  const viewOnly = viewOnlyProperties || viewOnlyLayout;

  return (
    <PropertiesPanel
      title="Feature Pattern Container"
      titleButton={<PropertiesPanelMenuButton type="featurePatternContainer" guid={props.value.guid} />}
    >
      <FeaturePatternContainerPropertyControls
        disabled={viewOnly}
        showMovementControls
        value={props.value}
        onChange={(changes) => {
          dispatch(editFeaturePatternContainers({ guid: props.value.guid, changes }));
        }}
      />
    </PropertiesPanel>
  );
}
